<template>
  <div>
    <div v-if="loading" class="loading-bar">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>
    <div v-else>
      <vx-card>
        <div>
          <!-- <ul>
        <li v-for="page in pages1" :key="page.name">
          <a @click.stop="stateChange(page.name)" :class="page.active">{{
            page.name
          }}</a>
        </li>
      </ul> -->
          <div class="w-full">
            <div
              slot="no-body"
              class="tabs-container inventory_tabSec"
              id="view-customer-tab"
            >
              <div class="mr-2 mb-1 order-1" style="">
                <vs-table
                  :max-items="descriptionItems[0]"
                  pagination
                  :data="teams"
                  description
                  search
                  :description-items="descriptionItems"
                  description-title="Registries"
                  description-connector="of"
                  description-body="Pages"
                >
                  <template slot="header">
                    <div class="mr-2 mb-1 order-1">
                      <vs-button
                        icon-pack="feather"
                        icon="icon-plus"
                        @click="$router.push({ name: 'Create Team' })"
                        size="small"
                        >{{ $t("setup.label.CreateTicketTeam") }}</vs-button
                      >
                    </div>
                  </template>
                  <template slot="thead">
                    <vs-th>{{ $t("setup.label.TeamHead") }}</vs-th>
                    <vs-th>{{ $t("setup.label.TeamCode") }}</vs-th>
                    <vs-th>{{ $t("setup.label.TeamDescription") }}</vs-th>
                    <vs-th>{{ $t("setup.label.TeamCategory") }}</vs-th>
                    <vs-th>{{ $t("setup.label.Status") }}</vs-th>
                    <vs-th class="tHeadCenter">{{
                      $t("setup.label.Actions")
                    }}</vs-th>
                  </template>

                  <template slot-scope="{ data }">
                    <vs-tr
                      :key="index"
                      :data="team"
                      v-for="(team, index) in data"
                    >
                      <vs-td :data="team.userName">{{ team.userName }}</vs-td>
                      <vs-td :data="team.teamCode">{{ team.teamCode }}</vs-td>
                      <vs-td :data="team.teamDescription">{{
                        team.teamDescription
                      }}</vs-td>
                      <vs-td :data="team.teamCategory">{{
                        team.teamCategory
                      }}</vs-td>
                      <vs-td :data="team.status">{{ team.status }}</vs-td>

                      <vs-td class="whitespace-no-wrap">
                        <div class="container_img">
                          <feather-icon
                            icon="EyeIcon"
                            title="View"
                            svgClasses="w-5 h-5 stroke-current cursor orange_icon"
                            @click.stop="handleTeamSelected(team.id)"
                            class="icon_row"
                          />
                          <feather-icon
                            icon="EditIcon"
                            title="Edit"
                            svgClasses="w-5 h-5 stroke-current cursor orange_icon"
                            @click.stop="editTeam(team.id)"
                            class="icon_row"
                          />
                          <feather-icon
                            icon="TrashIcon"
                            title="Delete"
                            svgClasses="w-5 h-5 text-danger stroke-current cursor"
                            @click.stop="
                              delId = team.id;
                              toggleTeam = true;
                              deleteTicketPopup = true;
                            "
                            class="icon_row"
                          />
                        </div>
                      </vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
              </div>
            </div>
          </div>
        </div>
        <delete-popup
          :deletePopup="deleteTicketPopup"
          :title="toggleTeam ? 'Team' : 'Team User'"
          @deletePressed="toggleTeam ? deleteTeam(delId) : deleteTicket(delId)"
          @cancelPressed="deleteTicketPopup = false"
        >
        </delete-popup>
      </vx-card>
    </div>
  </div>
</template>
<script>
import { AtomSpinner } from "epic-spinners";
import { mapState } from "vuex";
import DeletePopup from "@/components/DeletePopup.vue";

export default {
  data() {
    return {
      loading: false,
      searchOption: 0,
      toggleTeam: true,
      descriptionItems: [5, 10, 15],
      deleteTicketPopup: false,
      delId: 0,
      activeTab: 0,
      pages1: [
        { name: "Team", active: "active" },
        { name: "Team User", active: "inactive" },
      ],
    };
  },
  components: {
    AtomSpinner,
    "delete-popup": DeletePopup,
  },

  computed: {
    ...mapState({
      teams: (state) => state.teams.teamList,
    }),
  },
  methods: {
    handleTeamSelected(selectedId) {
      this.$router.push({ name: "View Team", params: { id: selectedId } });
    },
    async getTeamData() {
      this.loading = true;
      try {
        this.$store.dispatch("teams/setTeamData");
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
      this.loading = false;
    },

    editTeam(id) {
      this.$router.push({ name: "Edit Team", params: { id: id } });
    },

    async deleteTeam(id) {
      this.toggleTeam = true;
      try {
        await this.$store.dispatch("teams/deleteTeamAction", id);
        this.getTeamData();
        this.deleteTicketPopup = false;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
  },

  mounted() {
    this.getTeamData();
  },
};
</script>
<style scoped>
.vs-table--search {
  max-width: 100%;
  margin-left: 0px !important;
}

.vuesax-app-is-ltr .vs-table--search {
  margin-left: 0;
}

.vs-search-categeory {
  margin-top: 17px;
}
ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  overflow: hidden;
  background-color: rgba(var(--vs-primary), 1) !important;
  border-radius: 0.2rem;
}

li {
  float: left;
  font-weight: 550;
  font-size: 0.8rem;
  cursor: pointer;
}

li a {
  display: block;
  color: #fff;
  text-align: center;
  padding: 14px 16px;
  text-decoration: none;
  border: solid 0.2rem rgba(var(--vs-primary), 1);
}

li a:hover:not(.active) {
  border: solid 0.2rem rgba(var(--vs-primary), 1) !important ;
  background-color: #fff;
  color: rgba(var(--vs-primary), 1);
  box-shadow: rgba(var(--vs-primary), 1) 0px 7px 29px 0px;
}

.product-order-status.vs-chip-success {
  background: #d5ebdb !important;
  border: 1px solid #34a853;
  color: #34a853 !important;
}
.product-order-status.vs-chip-orange {
  background: #fffae7 !important;
  border: 1px solid #ffcb14;
  color: #ffcb14 !important;
}
.view_editTable_btn {
  background: transparent;
  cursor: pointer;
}

.inventory_tabSec >>> .con-vs-tabs .con-ul-tabs {
  width: 40%;
  position: absolute;
  top: 1.3rem;
}
.inventory_tabSec >>> .con-vs-tabs .vs-tabs--ul {
  box-shadow: none !important;
}
</style>
